/** Section names and the fields of sections v2 in the Admin page editor (ST-10). */
export const pageSectionTypes = {
    hero: "Banner",
    products: "Products",
    imageText: "Image and text",
    text: "Text",
    faq: "Questions and answers",
    testimonials: "What customers say",
    countdown: "Countdown",
    orderForm: "Order form",
    heroSlider: "Banner slides",
    heroSplit: "Split banner",
    categoryTiles: "Category tiles",
    flashDeal: "Flash deal",
    lookbook: "Shop the look",
    beforeAfter: "Before and after",
    featureIcons: "Feature icons",
    marquee: "Scrolling line",
    logoWall: "Logos",
    ugcGrid: "Customer photos",
    video: "Video",
    comparisonTable: "Comparison table",
    stats: "Numbers",
    steps: "How it works",
    finder: "Product finder",
    bundle: "Buy together",
    deliveryInfo: "Delivery information",
    richBanner: "Image banner",
    recentlyViewed: "Recently viewed",
    storeLocator: "Our shops (branches shown on the shop)",
    orderAgain: "Order again (signed-in shoppers only)",
    authors: "Popular authors",
};
export const pageSectionFields = {
    title: "Heading",
    subtitle: "Subheading",
    buttonLabel: "Button text",
    buttonHref: "Button link (/products or https://…)",
    autoplay: "Move to the next slide by itself",
    videoFileId: "Background video (MP4)",
    videoHint: "Optional: a muted 10–20 s loop under 10 MB. It plays only on fast connections; otherwise the first slide's picture shows.",
    slides: "Slides",
    imageSide: "Image side",
    left: "Left",
    right: "Right",
    center: "Centre",
    chips: "Short points (up to 4)",
    style: "Style",
    grid: "Grid",
    circles: "Circles",
    large: "Large tiles",
    rail: "Scrolling row",
    tiles: "Categories (empty: your main categories)",
    categoryId: "Category",
    anyCategory: "Any category",
    endsAt: "Ends at",
    productIds: "Products",
    limit: "How many",
    imageFileId: "Image",
    spots: "Products in the photo",
    x: "Across (%)",
    y: "Down (%)",
    productId: "Product",
    noProduct: "No product",
    beforeImageFileId: "Before",
    afterImageFileId: "After",
    body: "Text",
    items: "Items",
    icon: "Icon",
    text: "Text",
    truck: "Delivery truck",
    cash: "Cash",
    shield: "Shield",
    refresh: "Exchange",
    gift: "Gift",
    phone: "Phone",
    star: "Star",
    leaf: "Leaf",
    clock: "Clock",
    badge: "Badge",
    speed: "Speed",
    slow: "Slow",
    normal: "Normal",
    fast: "Fast",
    imageFileIds: "Logos",
    caption: "Caption",
    url: "YouTube or Facebook video link",
    posterFileId: "Cover image (optional)",
    ours: "Your column",
    theirs: "Other column",
    rows: "Rows",
    label: "Label",
    value: "Number",
    suffix: "After the number (+, %)",
    question: "Question",
    answers: "Answers",
    href: "Link (/products?category=… or /search?q=…)",
    checker: "Show the district delivery checker",
    align: "Text position",
    layout: "Show as",
    carousel: "Swipe row",
    menu: "Menu list",
    format: "Formats",
    formatAny: "Hard copy and digital",
    formatPhysical: "Hard copies only",
    formatDigital: "Digital only (eBooks)",
    addItem: "Add",
    addImage: "Add image",
    addProduct: "Add product",
    remove: "Remove",
    realDeadline: "Use a real end time. The deal disappears once it has passed.",
};
//# sourceMappingURL=storefront-sections.js.map